export const DEFAULT_COLORS = {
  row1: [
    'var(--color-navi-40)',
    'var(--color-navi-60)',
    'var(--color-navi-80)',
    'var(--gray-dark)',
  ],
  row2: [
    'var(--color-danger-light)',
    'var(--color-danger-punch)',
    'var(--color-danger-main)',
    'var(--color-danger-berry)',
  ],
  row3: [
    'var(--color-alternate-perfume)',
    'var(--color-alternate-violet)',
    'var(--color-alternate-light)',
    'var(--color-alternate-main)',
  ],
  row4: [
    'var(--color-yellow-light)',
    'var(--color-warning-light)',
    'var(--color-warning-main)',
    'var(--color-warning-dark)',
  ],
  row5: [
    'var(--color-success-mint)',
    'var(--color-success-aura)',
    'var(--color-success-main)',
    'var(--color-success-dark)',
  ],
  row6: [
    'var(--color-primary-light)',
    'var(--color-primary-main)',
    'var(--color-primary-web)',
    'var(--color-primary-dark)',
  ],
}

export const COLOR_PLACEHOLDER = '#ff99aa or var(--color-black)'
